import React, { useState } from "react";
import { useIntl } from "react-intl";

//Components
import { InputNumeric } from '@gpstrackit/gtc-react-controls';

const WarningController = (props) => {
    const { value, onChange, isDisabled } = props
    const { messages } = useIntl();

    //Local States
    const [editable, setEditable] = useState(false)

    return (
        <div onBlur={() => { if (value?.cnt <= 10) setEditable(false) }}>
            {
                editable ? (
                    <div className="camera-setup-warning-controller">
                        <InputNumeric
                            id="maxLength"
                            type="number"
                            value={value?.cnt}
                            onChange={(value) => {
                                let currentValue = value
                                if (value > 10)
                                    currentValue = 10
                                onChange(currentValue)
                            }}
                            isInteger={true}
                            min={1}
                            max={10}
                            maxLength={2}
                        />
                        {value?.cnt > 10 && <small className="text-danger">Max 10</small>}
                    </div>
                ) : (
                    <div
                        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                        onClick={() => {
                            !isDisabled && setEditable(true)
                            if (!value?.enable) {
                                onChange(value?.cnt)
                            }
                        }}
                    >
                        {
                            (value?.enable && !isDisabled) ? <a style={{ color: '#1F079B', textDecoration: 'underline', fontWeight: 600, opacity: isDisabled && 0.5 }}>{messages['cameraSetup_on']} {value?.cnt}</a> : <a style={{ color: '#1F079B', textDecoration: 'underline', fontWeight: 600, opacity: isDisabled && 0.5 }}>{messages['cameraSetup_off']}</a>
                        }
                    </div >
                )
            }
        </div>
    )
}

export default WarningController